import { getFormattedDate } from '../utils'

/**
 * Appends enrollment window dates to a status tooltip if an enrollment event exists.
 *
 * It returns an html string that should be sanitized and used as the content of
 * a tooltip.
 *
 * @param statusTip - The base status tooltip text
 * @param enrollmentEvent - Optional enrollment event containing window dates
 * @returns An html string that should be sanitized and used as the content of a tooltip
 */
export const getStatusTipWithEnrollmentWindow = (
  statusTip: string,
  enrollmentEvent?: { enrollment_window_start_date: string; enrollment_window_end_date: string } | null
): string => {
  if (enrollmentEvent == null) {
    return statusTip
  }

  const startDate = getFormattedDate(enrollmentEvent.enrollment_window_start_date)
  const endDate = getFormattedDate(enrollmentEvent.enrollment_window_end_date)

  return `${statusTip}<br><br>Enrollment window: ${startDate} - ${endDate}`
}
